export default {
  header: {
    self: {},
    items: [
     
    ]
  },
  aside: {
    self: {},
    items: [
      {
        title: "Dashboard",
        root: true,
        icon: "flaticon2-browser-2",
        page: "dashboard",
        /*translate: "MENU.DASHBOARD",*/
        bullet: "dot"
      },
      {
        title: "Master",
        root: true,
        icon: "flaticon2-gear",
        page: "patient",
        /*translate: "MENU.DASHBOARD",*/
        bullet: "dot",
         submenu: [
          {
            title: "Pending Approval",
            bullet: "dot",
            page: "approval"
          },
          {
            title: "Role",
            bullet: "dot",
            page: "role"
          },
          {
            title: "Business Type",
            bullet: "dot",
            page: "businessentity"
          },
          {
            title: "User",
            bullet: "dot",
            page: "user"
          },
          {
            title: "Account",
            bullet: "dot",
            page: "account"
          }

          
          ]

      },
      {
        title: "My Patients",
        root: true,
        icon: "flaticon2-group",
        page: "patient",
        /*translate: "MENU.DASHBOARD",*/
        bullet: "dot",
         submenu: [
          {
            title: "Emma Jones",
            bullet: "dot",
            page: "patient/12"
          },
          {
            title: "Femmi",
            bullet: "dot",
            page: "patient/13"
          },
          {
            title: "Vernon",
            bullet: "dot",
            page: "patient/14"
          },
          {
            title: "View All",
            bullet: "dot",
            page: "patient"
          }
          ]

      },
      
      
      {
        title: "Referrals",
        root: true,
        icon: "flaticon2-architecture-and-city",
        page: "referral",
        /*translate: "MENU.DASHBOARD",*/
        bullet: "dot"
      },
      {
        title: "Labs",
        root: true,
        icon: "flaticon2-drop",
        page: "lab",
        /*translate: "MENU.DASHBOARD",*/
        bullet: "dot"
      },
      {
        title: "Vendors",
        root: true,
        icon: "flaticon2-user-outline-symbol",
        page: "vendor",
        /*translate: "MENU.DASHBOARD",*/
        bullet: "dot"
      },
      {
        title: "Reports",
        root: true,
        icon: "flaticon2-graphic-1",
        page: "report",
        /*translate: "MENU.DASHBOARD",*/
        bullet: "dot"
      },
       {
        title: "Notifications",
        root: true,
        icon: "flaticon2-chat-1",
        page: "notification",
        /*translate: "MENU.DASHBOARD",*/
        bullet: "dot"
      },
      {
        title: "History",
        root: true,
        icon: "flaticon2-graph",
        page: "history",
        /*translate: "MENU.DASHBOARD",*/
        bullet: "dot"
      },
     
    ]
  }
};
